module.exports = __webpack_public_path__ + "images/fa-language-light.svg";